import { defineMessages } from 'react-intl';

export default defineMessages({
    policyDetailsTitle: {
        id: 'renewal.wizard.step.Policy Details',
        defaultMessage: 'Policy Details',
    },
    effectiveDate: {
        id: 'twia.renewal.views.contact-details.Requested Coverage Start Date',
        defaultMessage: 'Requested Coverage Start Date',
    },
    fieldLabel: {
        id: 'twia.renewal.ho.views.policy-info.Primary Named Insured',
        defaultMessage: 'Primary Named Insured',
    },
    fieldLabelCompany: {
        id: 'twia.renewal.ho.views.policy-info.Name',
        defaultMessage: 'Name',
    },
    saveModalTitle: {
        id: 'twia.renewal.ho.views.policy-info.Please save or cancel',
        defaultMessage: 'Please save or cancel',
    },
    saveModalText: {
        id: 'twia.renewal.ho.views.policy-info.Please save or cancel changes before continuing',
        defaultMessage: 'Please save or cancel changes before continuing',
    }
})